import { Tabs } from "antd";
import style from './CreateDocument.module.scss';
import useSetTitle from "../../hooks/useSetTitle";
import { FileTextOutlined, SolutionOutlined, ShoppingCartOutlined, SafetyOutlined } from "@ant-design/icons";
import { documentTemplates } from "../../const";

import Generator1 from "./generators/generator1";
import Generator2 from "./generators/generator2";
import Generator3 from "./generators/generator3";
import Generator4 from "./generators/generator4";
import Generator5 from "./generators/generator5";
import Generator6 from "./generators/generator6";
import Generator7 from "./generators/generator7";
import Generator8 from "./generators/generator8";
import Generator9 from "./generators/generator9";
import Generator10 from "./generators/generator10";
import Generator11 from "./generators/generator11";

function Templates() {

    useSetTitle('Создание документа по шаблону')
    const { TabPane } = Tabs;

   return (
        <Tabs 
            defaultActiveKey="1"
            tabPosition={window.innerWidth > 900 ? 'left' : 'top'}
            className={style.tabs}
        >
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.extractStorage}</>} key="1">
                <Generator1 />
            </TabPane>
            <TabPane tab={<><SolutionOutlined /> {documentTemplates.paidLeave}</>} key="2">
                <Generator2 />
            </TabPane>
            <TabPane tab={<><ShoppingCartOutlined /> {documentTemplates.purchaseOfService}</>} key="3">
                <Generator6 />
            </TabPane>
            <TabPane tab={<><FileTextOutlined />{documentTemplates.partTimeWork}</>} key="4">
                <Generator3 />
            </TabPane>
            <TabPane tab={<><SafetyOutlined /> {documentTemplates.passToGGNTU}</>} key="5">
                <Generator4 />
            </TabPane>
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.deliveryNote}</>} key="6">
                <Generator5 />
            </TabPane>
            {/* Добавьте остальные TabPane по аналогии */}
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.technicalExaminationReport}</>} key="7">
                <Generator7 />
            </TabPane>
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.applicationForPurchase}</>} key="8">
                <Generator8 />
            </TabPane>
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.applicationForAhch}</>} key="9">
                <Generator9 />
            </TabPane>
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.acceptanceCertificate}</>} key="10">
                <Generator10 />
            </TabPane>
            <TabPane tab={<><FileTextOutlined /> {documentTemplates.forInternalRelocation}</>} key="11">
                <Generator11 />
            </TabPane>
        </Tabs>
    );
}

export default Templates;